import timeFormAPI from '../../api/ui/timeFormAPI';
import { create } from './table-schema';
import useTranslation from '../../hooks/useTranslation';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

function useSchemaCarSocketLog() {
  const { t } = useTranslation();
  const locale = useSelector((state) => state.language.locale);

  /**
   * 테이블 헤더에 표시할 항목 문자열 배열
   */
  const headerKeys = [
    'admin.log.perplay.car.socket.table.head.no', // "로그 번호",
    "유저 ID",
    'admin.log.perplay.car.socket.table.head.nft', // "NFT UID",
    'admin.log.perplay.car.socket.table.head.name', // "아이템 이름(ID)",
    'admin.log.perplay.car.socket.table.head.socket', // "소켓",
    'admin.log.perplay.car.socket.table.head.type', // "작업 구분",
    'admin.log.perplay.car.socket.table.head.create', // "로그 생성 시각",
  ];

  const getSocketName = (row) => {
    switch (row?.socketIndex ?? -1) {
      case 4:
        return '무지개';
      case 10:
        return '엔진';
      case -1:
        return 'unknown';
      default:
        return `${row.socketIndex + 1}`;
    }
  };

  /**
   * 서버로부터 전달받은 request를 테이블에 표시할 내용으로 변환한다.
   * @param {object} row
   * @returns
   */
  const parse = (row) => {
    const no = row?.logNo || 0;
    const nft = row?.nftUid || 0;
    const email = row?.email || '';
    const accountNo = row?.accountNo || 0;
    const itemName = row?.gemName || '';
    const itemId = row?.gemId || 0;
    const socket = getSocketName(row);
    const type = row.type === 'mount' ? '장착' : '제거';
    const createAt = timeFormAPI.changeDataLog(row?.createdAt);

    return {
      key: no, // 키는 반드시 있어야 한다.
      param1: no,
      param2 : accountNo,
      param3: nft,
      param4: `${itemName} (${itemId})`,
      param5: socket,
      param6: type,
      param7: createAt,
    };
  };

  /**
   * 로그 데이터를 클릭했을 때 보여줄 디테일 다이얼로그에 보여줄 항목을 작성한다.
   *
   * 입력값인 row는 위의 parse에서 변환된 값이다.
   *
   * @param {object} row
   * @returns
   */
  const details = (row) => {
    const array = [];
    if (row) {
      //
    }
    return array;
  };

  const [schema, setSchema] = useState();

  useEffect(() => {
    const headers = headerKeys.map((key) => t(key));
    const schema = create({
      heads: headers,
      parseFunc: parse,
      detailFunc: details,
    });
    setSchema(schema);
  }, [locale]);

  return { schema: schema };
}

export default useSchemaCarSocketLog;
